module.exports = __webpack_public_path__ + "img/ia-02-2.f252b121.jpg";